import { LogArgument } from 'rollbar';
import init from './init';
import logEvent from './logEvent';
import recommendBanners from './recommendBanners';
import recommendSponsoredProducts from './recommendSponsoredProducts';
import searchSponsoredProducts from './searchSponsoredProducts';
import Rollbar from './utils/rollbar';

const digestCommandQueue = async () => {
  // @ts-expect-error FIXME:
  while (window.__rmn?.rmn?.queue?.length > 0) {
    // @ts-expect-error FIXME:
    const args = window.__rmn.rmn.queue.shift();
    const [method, ...params] = args;

    switch (method) {
      case 'init':
        init(params[0]);
        break;

      case 'getPaidProductsBySearch':
        // params[1] is callback
        await searchSponsoredProducts(params[0], params[1]);
        break;

      case 'searchSponsoredProducts':
        // params[1] is callback
        await searchSponsoredProducts(params[0], params[1]);
        break;

      case 'recommendBanners':
        // params[1] is callback
        await recommendBanners(params[0], params[1]);
        break;

      case 'recommendSponsoredProducts':
        // params[1] is callback
        await recommendSponsoredProducts(params[0], params[1]);
        break;

      case 'logEvent':
        // params[0] is eventName
        logEvent(params[0], params[1]);
    }
  }
};

async function main() {
  try {
    await digestCommandQueue();
  } catch (error) {
    Rollbar.error(error as LogArgument);
  }
}

main();

const rmn = {
  init,
  /** @deprecated: use searchSponsoredProducts instead */
  getPaidProductsBySearch: searchSponsoredProducts,
  searchSponsoredProducts,
  recommendBanners,
  recommendSponsoredProducts,
  logEvent,
  CODE_VERSION: import.meta.env.VITE_CODE_VERSION,
};

window.rmn = rmn;
